module.exports = __webpack_public_path__ + "img/cause1Red.264c60a0.png";